import React from 'react';

const FormBtn = ({ value, type }) => {
  return (
    <div
      className='d-flex justify-content-center'
      style={{ paddingBottom: '3rem' }}
    >
      <input type={type} value={value} className='form__btn' />
    </div>
  );
};

export default FormBtn;
